import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Image } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data } = this.props

    if(ajax_data != null) return (
      <div className={styles.newng}>
        <Container>
          <div className='d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between'>
            <div className={styles.newng_hw}>
              <div className={styles.newng_title}>НОВЫЕ ПОСТУПЛЕНИЯ</div>
              <div className={styles.newng_podpis}>Узнайте первыми о новых коллекциях бренда</div>
            </div>
            {'new_ng' in ajax_data &&
              <div className='d-none d-lg-flex align-itms-center justify-content-end'>
                {ajax_data.new_ng.map(( elm, i ) => {
                  if( elm.href != '' ) return (
                    <a href={elm.href} target="_blank" key={i} className={styles.newng_story}>
                      <div className={styles.newng_story_image}>
                        <Image src={elm.photo} width={71} height={71} alt="story" />
                      </div>
                      <div className={styles.newng_story_name}>{elm.title}</div>
                    </a>
                  )
                  return (
                    <div key={i} className={styles.newng_story}>
                      <div className={styles.newng_story_image}>
                        <Image src={elm.photo} width={71} height={71} alt="story" />
                      </div>
                      <div className={styles.newng_story_name}>{elm.title}</div>
                    </div>
                  )
                })}
              </div>
            }
            <div className={styles.newng_knovinkam + ' ' + styles.newng_hw + ' d-none d-lg-block'}>
              <a href={page_data.new_link}>Перейти →</a>
            </div>
          </div>
          <div className={styles.newng_sep + ` d-none d-lg-block`} />
          {'new_ng' in ajax_data &&
            <div className='d-flex align-items-start justify-content-between d-lg-none'>
              <Swiper
                modules={[FreeMode, Pagination]}
                pagination={{ type: `progressbar` }}
                spaceBetween={15}
                slidesPerView={`auto`}
                freeMode={true}
                className={`d-lg-none`}
                style={{ marginLeft: `0px` }}
                speed={300}
              >
                {ajax_data.new_ng.map(( elm, i ) => {
                  if( elm.href != '' ) return (
                    <SwiperSlide key={i} className={styles.newng_story_w}>
                      <a href={elm.href} target="_blank" key={i} className={styles.newng_story}>
                        <div className={styles.newng_story_image}>
                          <Image src={elm.photo} width={71} height={71} alt="story" />
                        </div>
                        <div className={styles.newng_story_name}>{elm.title}</div>
                      </a>
                    </SwiperSlide>
                  )
                  return (
                    <SwiperSlide key={i} className={styles.newng_story_w}>
                      <div className={styles.newng_story}>
                        <div className={styles.newng_story_image}>
                          <Image src={elm.photo} width={71} height={71} alt="story" />
                        </div>
                        <div className={styles.newng_story_name}>{elm.title}</div>
                      </div>
                    </SwiperSlide>
                  )
                })}
                <SwiperSlide className={styles.newng_story_w}></SwiperSlide>
              </Swiper>
              <div className={styles.newng_knovinkam} style={{ width: `auto`, marginBottom: `0px`, marginTop: `0px` }}>
                <a href={page_data.new_link}>Перейти →</a>
              </div>
            </div>
          }
        </Container>
      </div>
    )

    return (
      <></>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object
}